import { canAccessRole, UserRoleEnum } from '@entities/User';
import { ADMIN_TAB_KEYS, AdminTab, isAdminTab } from '@pages/AdminDashboard';
import { createFileRoute, redirect } from '@tanstack/react-router';

import { AdminDashboardRoutePage } from './-AdminDashboardRoutePage';

interface AdminSearch {
  tab: AdminTab;
}

export const Route = createFileRoute('/_app/__auth/admin/')({
  beforeLoad: ({ context }) => {
    const role = context.auth.user?.role;

    if (
      context.auth.user &&
      !canAccessRole(role, [UserRoleEnum.Admin, UserRoleEnum.Manager])
    ) {
      throw redirect({ to: '/' });
    }
  },
  component: AdminDashboardRoutePage,
  validateSearch: (search: Record<string, unknown>): AdminSearch => {
    const tab = typeof search.tab === 'string' ? search.tab : ADMIN_TAB_KEYS[0];

    return {
      tab: isAdminTab(tab) ? tab : ADMIN_TAB_KEYS[0],
    };
  },
});
